import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";
import { getColorFromTheme } from "../utils/style-utils";
import { reset } from "./reset";
import { down } from "styled-breakpoints";

export const GlobalStyle = createGlobalStyle`
    ${normalize}
    ${reset}
    body {
        font-family: ${(props) => props.theme.fontFamily};
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        text-rendering: geometricPrecision;
        height: 100%;
        background: #ffffff;
        min-width: 230px;
    }

    ${down("lg")} {
        body.mobile-scroll {
            overflow-y: visible !important;
        }
    }

    html, body {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        scroll-behavior: smooth;
    }

    #root {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    main {
        flex: 1;
    }

    * {
        box-sizing: border-box;
        border-width: 0;
        border-style: solid;
        border-top-style: solid;
        border-right-style: solid;
        border-bottom-style: solid;
        border-left-style: solid;
        border-color: #e5e7eb;
    }

    img, video {
        max-width: 100%;
        height: auto;
        vertical-align: middle;
    }

    input:not([type="image" i], [type="range" i], [type="checkbox" i], [type="radio" i]) {
        overflow-clip-margin: 0px !important;
        overflow: clip !important;
    }

    button, input, optgroup, select, textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0px;
    }

    button, input, optgroup, select, textarea {
        font-family: inherit;
        font-feature-settings: inherit;
        font-variation-settings: inherit;
        font-size: 100%;
        font-weight: inherit;
        line-height: inherit;
        letter-spacing: inherit;
        color: inherit;
        margin: 0;
        padding: 0;
    }

    a:focus:not(.focus-visible),
    *:focus {
        outline: none;
        box-shadow: none;
    }

    a.focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px ${getColorFromTheme("yellow100")};
    }

    .rnc__notification-container--top-right {
        position: absolute !important;;
    }

    .pac-container {
        z-index: 100000 !important;
    }

    .custom_app_discount {
        text-decoration: line-through;
        color: var(--color-secondary);
    }

    .custom-divider {
        margin: 16px 0;
        height: 1px;
        background-color: #F2F2F2;
        border-color: #F2F2F2;
    }

    .btn-outline-secondary:active,
    .btn-outline-secondary:focus,
    .btn-outline-secondary:focus-visible,
    .btn-outline-secondary:focus-within,
    .btn-outline-secondary:hover {
        background-color: transparent !important;
        color: inherit;
    }

    .otp-input {
        > div {
            gap: .5em;

            .otp-input-number {
                padding: 12px;
            }
        }

        ${down("md")} {
            > div {
                gap: .25em;

                .otp-input-number {
                    padding: 7px !important;
                }
            }
        }

        ${down("sm")} {
            > div {
                > span {
                    display: none;
                }

                .otp-input-number {
                    padding: 7px !important;
                }
            }
        }
    }

    .invalid-error {
        width: 100%;
        margin-top: .25rem;
        font-size: .875em;
        color: var(--bs-form-invalid-color);
    }

    label .required {
        color: var(--bs-form-invalid-color);
    }

    .custom-btn-outline-secondary {
        color: var(--color-primary);
        border-color: var(--color-primary);

        &:active, &:focus-within {
            border-color: var(--color-primary);
            color: var(--color-primary);
        }
    }

    .custom-btn-outline-danger {
        color: white !important;
        border-color: var(--color-danger) !important;
        background-color: var(--color-danger) !important;
        &:hover{
            border-color: var(--color-danger) !important;
            background-color: var(--color-danger) !important;
        }
        &:active, &:focus-within {
            border-color: var(--color-danger) !important;
        }
    }

    .custom-app-btn {
        border-color: #0b9c07;
        background-color: #0b9c07;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-radius: 36px;
        padding: 8.5px;
        font-weight: 600;
        font-size: 1em;
        --bs-btn-font-family: Archivo;
        &:hover{
            background-color: #0b9c07!important;
            border-color: #0b9c07!important;
        }
        svg {
            margin-left: 4px;
        }
    }

    .inherit-all {
        all: inherit;
    }

    .avatar {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1000px;
        overflow: hidden;
        background-color: #AEDEAC;
        border: 1.5px solid var(--color-primary);
        margin-left: auto;
        margin-right: auto;

        span {
            color: var(--color-primary);
            font-weight: 600;
        }
    }

`;
